import axios from 'axios';

import { environment } from '@environments/environment';
import { generateFinalizedParamsPOST, generateParamsPOST } from './utils/OverviewServiceUtils';
import { PerformanceParam } from '@models/SalesPerformance';
import { getQueryClient } from '@queries/QueryClientWrapper';
import { throwApiError } from '@services/utils/ErrorHandlers';

export const getPerformance = async ({
  clientId,
  productType,
  productGroup,
  countries,
  period,
  comparisonPeriod,
  periodType,
  saleType,
  appliedFilters,
  isSummary,
}: PerformanceParam): Promise<any> => {
  const qc = getQueryClient('trading-assistant');

  let queryParams: any;

  try {
    if (!countries || !comparisonPeriod) {
      return;
    }

    return await qc.ensureQueryData({
      queryKey: [
        'trading-assistant-market-performance',
        {
          clientId,
          productType,
          productGroup,
          countries,
          period,
          comparisonPeriod,
          periodType,
          saleType,
          appliedFilters,
          isSummary,
        },
      ],
      queryFn: async () => {
        const params = generateParamsPOST({
          clientId,
          productGroup,
          countries,
          period,
          comparisonPeriod,
          periodType,
          saleType,
          appliedFilters,
          isSummary,
        });

        queryParams = generateFinalizedParamsPOST(params, productType, productGroup, params.country);

        const { data } = await axios.post(`${environment.baseUrl}/v2/market-performance`, queryParams);

        return data.valuePerformance.salesRecordsFound ? data : null;
      },
      retry: false,
    });
  } catch (err: any) {
    // Delegated error handling; helper always throws. Added explicit throw for Sonar compliance.
    throwApiError(err, { excludedBrand: queryParams?.excludedBrand }); // NOSONAR
  }
};
